/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CustomPersonalDetailTypes {
  MULTILINE = 'multiline',
  BOOLEAN = 'boolean',
  DROP_DOWN = 'drop_down',
}
